import "react-toastify/dist/ReactToastify.css";
import { ConfirmCancelButtons } from "@components/Buttons/ConfirmCancelButtons";
import PasswordForm from "@components/Forms/PasswordForm";
import { error_message, UserFieldErrorMessages } from "@constants/Errors";
import LoadingIcon from "@common/LoadingIcon";
import { UseUserPasswordResetForm } from "@components/Forms/UserPasswordResetForm/hooks/useUserPasswordResetForm";

export const UserPasswordResetForm = () => {
  const form = UseUserPasswordResetForm();
  return (
    <div>
      {form.loading ? (
        <LoadingIcon />
      ) : form.userData ? (
        <div className="mayo-card-body rounded-xl border border-mayo-light-gray">
          <div className="mb-5">
            <PasswordForm
              identifier="password"
              label="変更後のパスワード"
              password={form.newPassword}
              errors={form.errors.password}
              setError={form.updateError}
              setPassword={form.setNewPassword}
              modal={false}
            />
          </div>

          <div className="mt-5 mb-5">
            <PasswordForm
              identifier="verifyPassword"
              label="変更後のパスワード（再入力）"
              password={form.confirmPassword}
              errors={form.errors.verifyPassword}
              setError={form.updateError}
              setPassword={form.setConfirmPassword}
              modal={false}
            />
          </div>

          {form.errors.noMatch && (
            <p className="text-red-500">
              {UserFieldErrorMessages.passwordNoMatchError}
            </p>
          )}

          <div className="flex gap-2">
            <div className="pt-10 text-zinc-400 font-bold">
              パスワードポリシー:
            </div>
            <div className="pt-10 text-zinc-400 font-bold">
              {form.passwordPolicy}
            </div>
          </div>

          <ConfirmCancelButtons
            confirmText="変更する"
            onConfirm={form.onConfirm}
            onCancel={form.onCancel}
          />
        </div>
      ) : (
        <p className="not-found-text">{error_message.user.not_found}</p>
      )}
    </div>
  );
};
